"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceTypes = void 0;
var ServiceTypes;
(function (ServiceTypes) {
    ServiceTypes["AMAZON"] = "amazon";
    ServiceTypes["AMAZON_MUSIC"] = "amazonMusic";
    ServiceTypes["ANGHAMI"] = "anghami";
    ServiceTypes["AUDIOMACK"] = "audiomack";
    ServiceTypes["AUDIUS"] = "audius";
    ServiceTypes["AWA"] = "awa";
    ServiceTypes["BAJAO"] = "bajao";
    ServiceTypes["BANDCAMP"] = "bandcamp";
    ServiceTypes["BANDS_IN_TOWN"] = "bandsInTown";
    ServiceTypes["BANDSINTOWN"] = "bandsintown";
    ServiceTypes["BEATPORT"] = "beatport";
    ServiceTypes["BEATSTARS"] = "beatstars";
    ServiceTypes["BLEEP"] = "bleep";
    ServiceTypes["BOOMPLAY"] = "boomplay";
    ServiceTypes["CASH_APP"] = "cashApp";
    ServiceTypes["DEEZER"] = "deezer";
    ServiceTypes["DISCORD"] = "discord";
    ServiceTypes["DUBSMASH"] = "dubsmash";
    ServiceTypes["FACEBOOK"] = "facebook";
    ServiceTypes["GAANA"] = "gaana";
    ServiceTypes["GOOGLE"] = "google";
    ServiceTypes["GOOGLE_PLAY"] = "googleplay";
    ServiceTypes["I_HEART_RADIO"] = "iHeartRadio";
    ServiceTypes["INSTAGRAM"] = "instagram";
    ServiceTypes["ITUNES"] = "itunes";
    ServiceTypes["ITUNES_STORE"] = "itunesStore";
    ServiceTypes["JIO_SAAVN"] = "jioSaavn";
    ServiceTypes["JOOX"] = "joox";
    ServiceTypes["KKBOX"] = "kkbox";
    ServiceTypes["LAST_FM"] = "lastFm";
    ServiceTypes["LINE_MUSIC"] = "lineMusic";
    ServiceTypes["LINKED_IN"] = "linkedIn";
    ServiceTypes["MAILCHIMP"] = "mailchimp";
    ServiceTypes["MIXCLOUD"] = "mixcloud";
    ServiceTypes["MORA"] = "mora";
    ServiceTypes["MUSIXMATCH"] = "musixMatch";
    ServiceTypes["NAPSTER"] = "napster";
    ServiceTypes["ORCHARD"] = "orchard";
    ServiceTypes["OTOTOY"] = "ototoy";
    ServiceTypes["PANDORA"] = "pandora";
    ServiceTypes["PATREON"] = "patreon";
    ServiceTypes["PAYPAL"] = "paypal";
    ServiceTypes["QOBUZ"] = "qobuz";
    ServiceTypes["RAKUTEN"] = "rakuten";
    ServiceTypes["RECOCHOKU"] = "recochoku";
    ServiceTypes["RESSO"] = "resso";
    ServiceTypes["REVERB_NATION"] = "reverbNation";
    ServiceTypes["SEVEN_DIGITAL"] = "sevenDigital";
    ServiceTypes["SNAPCHAT"] = "snapchat";
    ServiceTypes["SONGWHIP"] = "songwhip";
    ServiceTypes["SOUND_CLOUD"] = "soundcloud";
    ServiceTypes["SPOTIFY"] = "spotify";
    ServiceTypes["TELEGRAM"] = "telegram";
    ServiceTypes["TICKETMASTER"] = "ticketmaster";
    ServiceTypes["TIDAL"] = "tidal";
    ServiceTypes["TIKTOK"] = "tiktok";
    ServiceTypes["TRAXSOURCE"] = "traxsource";
    ServiceTypes["TRILLER"] = "triller";
    ServiceTypes["TWITCH"] = "twitch";
    ServiceTypes["TWITTER"] = "twitter";
    ServiceTypes["VK"] = "VK";
    ServiceTypes["WYNK"] = "wynk";
    ServiceTypes["YANDEX"] = "yandex";
    ServiceTypes["YOU_TUBE"] = "youtube";
    ServiceTypes["YOU_TUBE_MUSIC"] = "youtubeMusic";
})(ServiceTypes || (exports.ServiceTypes = ServiceTypes = {}));
//# sourceMappingURL=types.js.map